export const allSelector = (state) => state?.creditNotesReducer?.all;
